// extracted by mini-css-extract-plugin
export default {"version":"MfeVersionDisplayer_version__Yq98T","releaseDate":"MfeVersionDisplayer_releaseDate__bq0TF","error":"MfeVersionDisplayer_error__M1lId"};